import Board from '../components/Board';

const Main = ()=> {

  return (
    <Board category='all' />
  )
};

export default Main;